import en from "./en.translation.json";
import es from "./es.translation.json";
import homeScreenTemplate from "./homescreen.html";
import _ from "lodash";

class HomeScreenController {
    $onInit() {
        let ctrl = this;
        ctrl.growersThatAllowYouToViewDocuments = _.filter(ctrl.growers, {
            allow_employees_to_view_own_documents: true,
        });
        ctrl.growersWithSOPLibrary = _.filter(ctrl.growers, {
            sop_library_has_content: true,
        });
    }
}

export default {
    bindings: {
        account: "<",
        activeMemberships: "<",
        groups: "<",
        incompletePaperworkRequests: "<",
        documentPackages: "<",
        myPaperwork: "<",
        neededMeetings: "<",
        growers: "<",
        managedGrowers: "<",
        managedCrewsData: "<",
    },
    template: homeScreenTemplate,
    name: "homeScreen",
    translations: { en, es },
    controller: HomeScreenController,
};
